import { Celebration, LoaderPage } from '@sloyd/ui';
import { useEffect, useState } from 'react';
import { Wrapper } from './ContentCelebration.style';

const DELAY = 3500;

export type ContentCelebrationProps = {
  celebrationType: CelebrationType;
  callbacks: {
    onNavigate: (path: string) => void;
  };
};

export function ContentCelebration(props: ContentCelebrationProps) {
  const { celebrationType, callbacks } = props;
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLoader(false);
    }, DELAY);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  function renderInner() {
    if (showLoader) {
      return <LoaderPage color='pink' />;
    }

    return <Celebration onNavigate={callbacks.onNavigate} type={celebrationType} />;
  }

  return (
    <Wrapper className='ContentCelebration-wrapper' data-testid='ContentCelebration-wrapper'>
      {renderInner()}
    </Wrapper>
  );
}

export default ContentCelebration;
